import React from 'react';

import { MergedIntervalWithDates, MonthTuple, weekdayNames, When } from '@src/common/calendar';
import { FeaturedTariffPreviewMode } from '@src/core/buyerApiClient';
import { classifyDay } from '@src/domains/scheduling';
import { useWeekdayFormatter } from '@src/domains/scheduling/hooks/useWeekdayFormatter';
import { Container, DateArea, DateAreaText, WeekDayNameArea } from './styles';

interface CalendarMonthViewProps {
  filteredDates: Array<MergedIntervalWithDates>;
  pending: boolean;
  monthTuple: MonthTuple;
  onSelectDate: (date: string) => void;
  tariffToShowThePrice?: FeaturedTariffPreviewMode | null;
}

const CalendarMonthView = (props: CalendarMonthViewProps) => {
  const { filteredDates, monthTuple, onSelectDate, pending, tariffToShowThePrice } = props;
  const { names: weekdayLabels } = useWeekdayFormatter();

  return (
    <Container aria-label='month-days'>
      {weekdayLabels.map((label, idx) => (
        <WeekDayNameArea key={weekdayNames[idx]} pending={pending}>
          {label}
        </WeekDayNameArea>
      ))}

      {filteredDates.map(({ date, availableSchedulings, unavailableSchedulings }) => {
        const { isAvailable, isSoldOut, price } = classifyDay({
          intervalDate: date,
          availables: availableSchedulings,
          unavailables: unavailableSchedulings,
          tariffPreviewMode: tariffToShowThePrice ?? null,
        });

        return (
          <DateArea
            onClick={() => (availableSchedulings?.length ? onSelectDate(date.dateString) : null)}
            isAvailable={isAvailable}
            key={date.dateString}
            when={date.when}
            pending={pending}
            isSoldOut={isSoldOut}
            date={new Date(date.year, date.month - 1, date.date)}
            selectedMonth={monthTuple[1]}
            aria-label='day-button'
            disabled={!isAvailable}
            aria-disabled={!isAvailable}
            data-cy={isAvailable ? 'available_scheduling' : 'disabled_scheduling'}
          >
            <DateAreaText data-testid='day' isAvailable={!!isAvailable} isFuture={date.when == When.FUTURE}>
              {date.date}
            </DateAreaText>

            {price ? (
              <DateAreaText isPrice isAvailable={!!isAvailable} isFuture={date.when == When.FUTURE}>
                {price.currency}
                {price.priceStr}
              </DateAreaText>
            ) : null}
          </DateArea>
        );
      })}
    </Container>
  );
};

export default CalendarMonthView;
